import styled from '@emotion/styled';
import { RichTextStyle } from '../RichText';

const Section = styled.section<{
  isHidden: boolean;
  textStyle: RichTextStyle;
}>`
  padding-top: ${({ theme }) => theme.spacing[60]};
  display: ${({ isHidden }) => (isHidden ? 'none' : 'block')};
  color: ${({ textStyle, theme }) =>
    textStyle === RichTextStyle.Alternative
      ? theme.colors.neutral.white100
      : theme.colors.neutral.grey160};

  &:focus-visible {
    outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
    outline-offset: 0.25rem;
  }
`;

export { Section };
